"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Badge = _interopRequireDefault(require("../Badge"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _Tab = require("./Tab.types");
var _context = require("../Tabs/context");
var _Typography2 = require("../Typography/Typography.types");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) {
    if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }
  return n["default"] = e, t && t.set(e, n), n;
}
/* eslint-disable no-nested-ternary */
var styles = {
  "listItem": "qR7hJo",
  "default": "lkc7-L",
  "active": "V0hdMV",
  "inverse": "xhWqQU"
};
var TabItem = function TabItem(_ref) {
  var id = _ref.id,
    label = _ref.label,
    initialActive = _ref.initialActive,
    setActiveTab = _ref.setActiveTab,
    activeTab = _ref.activeTab,
    kind = _ref.kind,
    badgeCount = _ref.badgeCount,
    staticBadge = _ref.staticBadge,
    badgeVariant = _ref.badgeVariant,
    dataTestid = _ref['data-testid'];
  var currentTabRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (initialActive && activeTab === '') {
      setTimeout(function () {
        return setActiveTab(id);
      });
    }
  });
  var isCurrentTabActive = activeTab === id;
  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === 'Enter') {
      setActiveTab(id);
    }
  };
  var setTypographyKind = function setTypographyKind(kind) {
    var isActive = isCurrentTabActive;
    if (kind === _Tab.Kind.INVERSE) {
      return isActive ? _Typography2.Kind.INVERSE : _Typography2.Kind.INVERSE_LIGHTER;
    }
    return isActive ? _Typography2.Kind.DEFAULT : _Typography2.Kind.LIGHTER;
  };
  (0, _react.useEffect)(function () {
    if (isCurrentTabActive) {
      var currentTab = currentTabRef.current;
      var tabs = currentTab.parentElement;
      var middlePosition = currentTab.offsetLeft - (tabs.offsetWidth - currentTab.offsetWidth) / 2;
      if (tabs.scrollWidth > tabs.clientWidth) {
        tabs.scrollTo({
          left: middlePosition,
          behavior: 'smooth'
        });
      }
    }
  }, [currentTabRef, isCurrentTabActive]);
  return /*#__PURE__*/_react["default"].createElement("li", {
    onClick: function onClick() {
      return setActiveTab(id);
    },
    onKeyDown: handleKeyDown,
    key: id,
    "aria-selected": isCurrentTabActive,
    role: "tab",
    tabIndex: 0,
    className: (0, _clsx["default"])('Cozy__Tab', styles.listItem, kind === _Tab.Kind.INVERSE ? styles.inverse : styles["default"], isCurrentTabActive && styles.active),
    ref: currentTabRef,
    "data-testid": dataTestid
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    level: _Typography2.Level.BODY_STRONG,
    kind: setTypographyKind(kind)
  }, label), badgeCount > 0 && /*#__PURE__*/_react["default"].createElement(_Badge["default"], {
    variant: badgeVariant,
    count: badgeCount
  }), staticBadge && badgeCount === 0 && /*#__PURE__*/_react["default"].createElement(_Badge["default"], {
    variant: badgeVariant
  }));
};
var Tab = function Tab(_ref2) {
  var id = _ref2.id,
    label = _ref2.label,
    initialActive = _ref2.initialActive,
    kind = _ref2.kind,
    badgeCount = _ref2.badgeCount,
    badgeVariant = _ref2.badgeVariant,
    staticBadge = _ref2.staticBadge,
    dataTestid = _ref2['data-testid'];
  return /*#__PURE__*/_react["default"].createElement(_context.TabsContext.Consumer, null, function (_ref3) {
    var activeTab = _ref3.activeTab,
      setActiveTab = _ref3.setActiveTab;
    return /*#__PURE__*/_react["default"].createElement(TabItem, {
      activeTab: activeTab,
      setActiveTab: setActiveTab,
      id: id,
      label: label,
      initialActive: initialActive,
      kind: kind,
      staticBadge: staticBadge,
      badgeCount: badgeCount,
      badgeVariant: badgeVariant,
      "data-testid": dataTestid
    });
  });
};
Tab.propTypes = process.env.NODE_ENV !== "production" ? {
  id: _propTypes["default"].string.isRequired,
  label: _propTypes["default"].string.isRequired,
  initialActive: _propTypes["default"].bool,
  kind: _propTypes["default"].oneOf(Object.values(_Tab.Kind)),
  badgeCount: _propTypes["default"].number,
  badgeVariant: _propTypes["default"].oneOf(Object.values(_Tab.BadgeVariant)),
  staticBadge: _propTypes["default"].bool,
  'data-testid': _propTypes["default"].string
} : {};
Tab.defaultProps = {
  initialActive: false,
  kind: _Tab.Kind.DEFAULT,
  badgeCount: 0,
  staticBadge: false,
  badgeVariant: _Tab.BadgeVariant.DEFAULT
};
var _default = exports["default"] = Tab;